import React from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { IdleHandler } from './IdleHandler.js';

var SessionController = function SessionController(_ref) {
  var instance = _ref.instance,
    timeout = _ref.timeout;
  // avoid duplicate if microFrontends are invoked via MyPages-main
  // the cookie "giid" is set in MGW upon SSO when we open the Microfrontends
  // without passing via MyPages-main

  if (instance !== 'MyPages_Main' && !Cookies.get('giid')) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IdleHandler, {
    timeout: timeout
  });
};
SessionController.propTypes = {
  instance: PropTypes.string,
  timeout: PropTypes.number
};
SessionController.defaultProps = {
  instance: null,
  timeout: 25 * 60 * 1000
};

export { SessionController as default };
